import React, { useContext, useState } from 'react'
import RegistrationDashboardLayout from './RegistrationDashboardLayout'
import eventContext from '../contexts/EventContext';
import Layout from './Layout';
import useGetFormulaireList from '../customHooks/UseGetFormulaireList';
import { GroupListSection } from './FormulaireList';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useGetFormulaireEventList from '../customHooks/UseGetFormulaireEventList';
import { API_URL } from '../config';

const RegistrationDashbordForms = () => {

    const { formulaireList } = useGetFormulaireList({ params: "WHERE id_formulaire IN (105, 153, 154)" });

    const { currentEvent } = useContext(eventContext);

    const { idEvent } = useParams();

    const [eventEventComposantList, setEventEventComposantList] = useState(null)

    const { formulaireEventList } = useGetFormulaireEventList({
        params: idEvent && idEvent
            ? `WHERE id_formulaire IN (105, 153, 154) AND id_event = ${idEvent}`
            : null
    });

    const { ownerIdContact } = useParams();


    const getEventEventComposant = async () => {

        await fetch(`${API_URL}action=getEventEventComposant&params=WHERE id_event = ${idEvent}`)
            .then(res => res.json())
            .then(res => {
                console.log(res);
                setEventEventComposantList(res)
            })
    }


    const groupData_ = [

        {
            groupName: "Créneaux d'intervention garantis pour votre portfolio",
            cibleList: [
                {
                    cibleName: "<p className='font-bold'>ESPACE GAME CHANGER </p> Table des liens Startup, scale up et pme innovantes et tout offreurs de solutions",
                    cibleCategory: [
                        // {
                        //     cibleCategoryName: "Lien startup,  scale-up, entreprise innovante…  présentant l'ensemble du programme sur lequel vous avez des créneaux réservés.",
                        //     formulaireIds: ["105"]
                        // },
                        {
                            cibleCategoryName: "Liens à envoyer à votre portefolio de GAME-CHANGERS : startup, scale-up, entreprise innovante… :",
                            formulaireIds: ["110", "118"]
                        }]
                },
                {
                    cibleName: "<p className='font-bold'>ESPACE KEY PLAYER</p>Elus, décideurs : early adopter, intégrateur, investisseur…",
                    cibleCategory: [
                        // {
                        //     cibleCategoryName: "Lien décideurs (élus, techniciens territoriaux, intégrateur, médias…)  présentant l'ENSEMBLE DU PROGRAMME  sur lequel vous avez des créneaux réservés.",
                        //     formulaireIds: ["107"]
                        // },
                        {
                            cibleCategoryName: "Liens à envoyer à votre portefolio de KEY-PLAYERS (élus, techniciens territoriaux, intégrateur, médias…)  :",
                            formulaireIds: currentEvent && currentEvent.id_event === "2099" ? ["109", "111", "106"] : ["108", "109", "111", "106"]
                        }]
                }
            ]
        }
    ]


    const groupData = [

        {
            groupName: "",
            cibleList: [
                {
                    cibleName: "",
                    cibleCategory: [
                        // {
                        //     cibleCategoryName: "Lien startup,  scale-up, entreprise innovante…  présentant l'ensemble du programme sur lequel vous avez des créneaux réservés.",
                        //     formulaireIds: ["105"]
                        // },
                        {
                            cibleCategoryName: "Bibliothèque de formulaires à  envoyer aux interviewés : ",
                            formulaireIds: ["105", "154", "153"]
                        }]
                }
            ]
        }
    ]

    return (
        <RegistrationDashboardLayout>


            {groupData.map(group => (
                <GroupListSection
                    key={group.groupName}
                    groupName={group.groupName}
                    cibleList={group.cibleList}
                    currentEvent={currentEvent}
                    formulaireList={formulaireList}
                    formulaireEventList={formulaireEventList}
                    ownerIdContact={ownerIdContact}
                />
            ))}



        </RegistrationDashboardLayout>
    )
}

export default RegistrationDashbordForms